import React, { Component } from 'react';

export class Blog extends Component {
    render() {
        return (
            <h1>Blog</h1>
        );
    }
}